// TODO: update when we support others
export default function getUnitName(unit: string) {
  if (unit === 'percent') {
    return '%';
  }
  return '%';
}
